import { Integration } from '../../utils/integrations.types';

export const IntegrationsTitle = ({
  integration,
}: {
  integration: Integration;
}) => {
  return (
    <div className="flex pr-l">
      <img src={integration.company_logo_svg} alt="Logo" className="pr-l" />
      <div className="m-auto">
        <div className="text-xs font-med text-secondary-40">
          {integration.company_type}
        </div>
        <h2 className="m-0 text-2xl font-bold max-800:text-xl">
          {integration.company_name}
        </h2>
      </div>
    </div>
  );
};
